import { shuffle } from 'lodash';

import React, { useRef } from 'react';

import {
  Carousel,
  LeftCircleOutlined,
  RightCircleOutlined,
} from 'opencare-crown';

import { reviews } from '../../../pages/funnel/components/Search/constants';

import {
  CarouselButton,
  CarouselContainer,
  CarouselSection,
  CarouselWrapper,
  Review,
  ReviewImg,
  ReviewName,
  ReviewTimestamp,
} from './styled-components';

export const ReviewCarousel = () => {
  const carousel = useRef();
  const nextReview = () => carousel.current.next();
  const previousReview = () => carousel.current.prev();

  return (
    <CarouselSection id="carousel-section">
      <CarouselContainer>
        <CarouselWrapper>
          <CarouselButton
            type="button"
            aria-label="Previous review"
            onClick={previousReview}
          >
            <LeftCircleOutlined />
          </CarouselButton>
          <Carousel
            ref={carousel}
            autoplay
            dots={false}
            autoplaySpeed={5000}
            effect="fade"
          >
            {shuffle(reviews).map((review) => (
              <div key={review.id}>
                <ReviewImg
                  src={review.img}
                  role="presentation"
                  alt=""
                  width={review.dimensions.width}
                  height={review.dimensions.height}
                />
                <Review>{review.review}</Review>
                <ReviewName>
                  {review.name} from {review.city}
                </ReviewName>
                <ReviewTimestamp>{review.days} days ago</ReviewTimestamp>
              </div>
            ))}
          </Carousel>
          <CarouselButton
            type="button"
            aria-label="Next review"
            onClick={nextReview}
          >
            <RightCircleOutlined />
          </CarouselButton>
        </CarouselWrapper>
      </CarouselContainer>
    </CarouselSection>
  );
};

ReviewCarousel.propTypes = {};
